import React, { useState } from "react";
import { Card } from "react-bootstrap";
import indiaFlag from "../../assets/images/Home/Flag_of_India.webp";
import axios from "axios";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
// import { getDeviceId } from "../../utils";

const getDeviceId = () => {
  let deviceId = localStorage.getItem("device_id");
  if (!deviceId) {
    deviceId = crypto.randomUUID(); // Generates a unique device ID
    localStorage.setItem("device_id", deviceId);
  }
  return deviceId;
};

const LoginLeft = ({ handleClose }) => {
  const [step, setStep] = useState("login");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);
  const queryParams = new URLSearchParams(window.location.search);
  const referralId = queryParams.get("ref");
  console.log(referralId);
  const [errors, setErrors] = useState({
    mobile: false,
    email: false,
    otp: false,
  });

  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setMobile(value);
    if (errors.mobile) setErrors({ ...errors, mobile: false });
  };

  const handleEmailChange = (e) => {
    let value = e.target.value;
    if (value.length <= 42) {
      setEmail(value);
    }
    if (errors.email) setErrors({ ...errors, email: false });
  };

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  // const handleSendOtp = async (e) => {
  //   e.preventDefault();
  //   let validationErrors = { mobile: false, email: false };

  //   if (!mobile) validationErrors.mobile = true;
  //   if (!email || !isValidEmail(email)) validationErrors.email = true;

  //   setErrors(validationErrors);
  //   if (validationErrors.mobile || validationErrors.email) return;

  //   setLoading(true);
  //   try {
  //     const res = await axios.post(
  //       `${process.env.REACT_APP_BASE_URL}/send-otp`,
  //       { mobile, email }
  //     );
  //     if (res.data.status === "1") {
  //       swal({
  //         title: "Success",
  //         text: "OTP sent to email",
  //         icon: "success",
  //         timer: 2000,
  //         buttons: false,
  //       });
  //       setStep("otp");
  //     } else {
  //       swal({
  //         title: "Error",
  //         text: res.data.message,
  //         icon: "error",
  //         timer: 2000,
  //         buttons: false,
  //       });
  //     }
  //   } catch (err) {
  //     swal("Error", err.message, "error");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSendOtp = async (e) => {
    e.preventDefault();
    let validationErrors = { mobile: false, email: false, terms: false };

    // Mobile validation
    if (!mobile) {
      validationErrors.mobile = "Mobile number is required";
    } else if (mobile.length !== 10) {
      validationErrors.mobile = "Mobile number should be 10 digits";
    }

    // Email validation
    if (!email) {
      validationErrors.email = "Email is required";
    } else if (!isValidEmail(email)) {
      validationErrors.email = "Enter a valid email address";
    }

    // Terms checkbox validation
    if (!isChecked) {
      validationErrors.terms = "You must agree to the terms and conditions";
    }

    setErrors(validationErrors);

    // If there are any validation errors, return early
    if (
      validationErrors.mobile ||
      validationErrors.email ||
      validationErrors.terms
    )
      return;

    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/send-otp`,
        { mobile, email, device_id: getDeviceId() }
      );
      if (res.data.status === "1") {
        swal({
          title: "Success",
          text: "OTP sent to email",
          icon: "success",
          timer: 2000,
          buttons: false,
        });
        setStep("otp");
      } else {
        swal({
          title: "Error",
          text: res.data.message,
          icon: "error",
          timer: 2000,
          buttons: false,
        });
      }
    } catch (err) {
      swal("Error", err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    if (!otp) {
      setErrors({ ...errors, otp: true });
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/verify-otp`,
        {
          mobile,
          email,
          otp,
          reffer_by: referralId,
          user_type: "customer",
          device_id: getDeviceId(),
        }
      );
      if (res.data.status === "1") {
        swal({
          title: "Success",
          text: "Login successful",
          icon: "success",
          timer: 2000,
          buttons: false,
        });
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("user_id", res.data.data.id);
        localStorage.setItem("username", res.data.data.username);
        localStorage.setItem("mobile", res.data.data.mobile);
        localStorage.setItem("email", res.data.data.email);

        handleClose();

        const redirectPath = localStorage.getItem("postLoginRedirect");

        if (redirectPath && redirectPath !== "/" && redirectPath !== "/login") {
          navigate(redirectPath, { replace: true });
        } else {
          navigate("/dashboard", { replace: true });
        }



        // navigate(window.location.pathname, { replace: true });
        // navigate("/dashboard");
        // window.location.reload();
      } else {
        swal({
          title: "Error",
          text: res.data.message,
          icon: "error",
          timer: 9000,
          buttons: false,
        });
        // handleClose();
      }
    } catch (err) {
      swal("Error", err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="form_page">
      <Card className="p-2 py-md-4 px-md-4">
        <div className="form_block">
          <div className="text_block">
            <div className="title mb-2">
              {step === "login" ? (
                <p>Enter your mobile number and email</p>
              ) : (
                <p>Enter the OTP sent to your email</p>
              )}
            </div>

            {step === "login" ? (
              <form onSubmit={handleSendOtp} noValidate>
                <label>Mobile Number</label>
                <div className="login_input mb-3">
                  <span className="flagCode">
                    <img src={indiaFlag} width={20} alt="flag" /> +91
                  </span>
                  <input
                    type="text"
                    inputMode="numeric"
                    value={mobile}
                    onChange={handleMobileChange}
                    placeholder="Enter mobile"
                    maxLength={10}
                    className={`form-control ${errors.mobile ? "is-invalid" : ""
                      }`}
                  />
                  {errors.mobile && (
                    <div className="text-danger">{errors.mobile}</div>
                  )}
                </div>

                <label>Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={handleEmailChange}
                  maxLength={42}
                  placeholder="Enter email"
                  className={`form-control mb-2 ${errors.email ? "is-invalid" : ""
                    }`}
                />
                {errors.email && (
                  <div className="text-danger">{errors.email}</div>
                )}

                <div className="form-group term_checkbox m-1 mb-3">
                  <input
                    type="checkbox"
                    checked={isChecked}
                    id="exampleCheck1"
                    onChange={(e) => setIsChecked(e.target.checked)}
                    className={errors.terms ? "is-invalid" : ""}
                  />
                  <label className="form-check-label" htmlFor="exampleCheck1">
                    By registering you agree to the{" "}
                    <a target="_blank" href="/terms">
                      Terms of Use
                    </a>
                    .
                  </label>
                </div>
                {errors.terms && (
                  <div className="text-danger">{errors.terms}</div>
                )}

                <button
                  type="submit"
                  disabled={loading}
                  className="b-unstyle educate-btn w-100 mb-3"
                >
                  {loading ? "Sending OTP..." : "Send OTP"}
                </button>
              </form>
            ) : (
              <form onSubmit={handleVerifyOtp} noValidate>
                {referralId && (
                  <div className="mb-24">
                    <label htmlFor="referral" className="form-label">
                      Refer
                    </label>
                    <input
                      type="text"
                      className="form-control p_lg"
                      name="referral"
                      value={referralId}
                      readOnly
                    />
                  </div>
                )}
                <label>OTP</label>
                <input
                  type="text"
                  inputMode="numeric"
                  value={otp}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, "");
                    setOtp(value);
                  }}
                  placeholder="Enter OTP"
                  maxLength={6}
                  className={`form-control mb-3 ${errors.otp ? "is-invalid" : ""
                    }`}
                />

                <button
                  type="submit"
                  disabled={loading}
                  className="b-unstyle educate-btn w-100 mb-3"
                >
                  {loading ? "Verifying..." : "Verify OTP"}
                </button>
              </form>
            )}
          </div>
        </div>
      </Card>
    </section>
  );
};

export default LoginLeft;
